<template>
  <div v-if="!this.sent" class="md:mx-6 mt-6 py-4">
    <div class="text-2xl font-bold">
      Contact {{this.$store.state.instructorModule.selectedInstructor.name}}
    </div>
    <div class="font-bold text-lg">My contact information... </div>
    <div class="flex my-4">
      <STInput
        v-model="form.studentFirstName"
        :options="inputOptions.firstName"
        class="w-1/2 mr-2 border-b-2 border-gray-200"
      />
      <STInput
        v-model="form.studentLastName"
        :options="inputOptions.lastName"
        class="w-1/2 ml-2  border-b-2 border-gray-200"
      />
    </div>
      <STInput
        v-model="form.studentEmail"
        :options="inputOptions.email"
        class="w-full mr-2 border-b-2 border-gray-200 my-4"
      />
    <div class="font-bold text-lg">I'd like lessons on... </div>
    <div class="flex my-4">
      <div class="relative w-1/2 mr-2">
        <STSelect
          v-model="form.day"
          :options="selectOptions.dayOfWeek"
        />
      </div>
      <div class="relative w-1/2 ml-2">
        <STSelect
          v-model="form.time"
          :options="selectOptions.timeOfDay"
        />
      </div>
    </div>
    <STButton
      class="w-full"
      :options="buttonOptions.send"
      @click.native="handleSubmit"
    />
    <p v-if="hasErrors" class="my-4 text-red-500">
      <b>Please correct the following error(s):</b>
      <ul class="list-disc">
        <li v-for="error in form.errors" :key="error" class="ml-8">{{ error }}</li>
      </ul>
    </p>
  </div>
  <div v-else>
    <p class="h-full text-4xl p-4"> Thank you for contacting {{this.$store.state.instructorModule.selectedInstructor.name}}.</p>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: 'strumm'
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}
export default {
  name: 'InstructorProfileContact',
  data () {
    return {
      sent: false,
      inputOptions: {
        'firstName': {
          'type': 'text',
          'placeholder': 'First name'
        },
        'lastName': {
          'type': 'text',
          'placeholder': 'Last name'
        },
        'email': {
          'type': 'email',
          'placeholder': 'Enter your email'
        }
      },
      selectOptions: {
        'dayOfWeek': {
          'placeholder': 'Day of the Week',
          'values': {
            'Sunday': 'Sunday',
            'Monday': 'Monday',
            'Tuesday': 'Tuesday',
            'Wednesday': 'Wednesday',
            'Thursday': 'Thursday',
            'Friday': 'Friday',
            'Saturday': 'Saturday'
          }
        },
        'timeOfDay': {
          'placeholder': 'Time of Day',
          'values': {
            'Mornings': 'Mornings',
            'Afternoons': 'Afternoons',
            'Evenings': 'Evenings'
          }
        }
      },
      buttonOptions: {
        'send': {
          'text': 'Submit Form'
        }
      },
      form: {
        studentFirstName: null,
        studentLastName: null,
        studentEmail: null,
        day: null,
        time: null,
        instructorName: this.$store.state.instructorModule.selectedInstructor.name,
        instructorEmail: 'info@strumm.co',
        instructorLink: `https://www.strumm.co/instructor/${this.$store.state.instructorModule.selectedInstructor.place_id}`,
        errors: []
      }
    }
  },
  computed: {
    hasErrors () {
      return this.form.errors.length > 0
    }
  },
  methods: {
    handleSubmit (e) {
      // TODO: use vuelidate.js
      // TODO: validate inline
      this.form.errors = []

      // only send once.  Is this the easiest way?  early return?
      if (this.sent === true) {
        return
      }

      if (!this.form.studentFirstName) {
        this.form.errors.push('Your first name is required.')
      }

      if (!this.form.studentLastName) {
        this.form.errors.push('Your last name is required.')
      }

      if (!this.form.day) {
        this.form.errors.push('Preferred day is required.')
      }

      if (!this.form.time) {
        this.form.errors.push('Preferred time is required.')
      }

      if (!this.form.studentEmail) {
        this.form.errors.push('Email required.')
      } else if (!this.validEmail(this.form.studentEmail)) {
        this.form.errors.push('Valid email required.')
      }

      if (!this.form.errors.length) {
        this.sendMessage()
        return true
      }

      e.preventDefault()
    },
    validEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    sendMessage () {
      const callable = firebase.functions().httpsCallable('emailMessage')
      callable({
        student: `${this.form.studentFirstName} ${this.form.studentLastName}`,
        instructorLink: this.form.instructorLink,
        day: this.form.day,
        time: this.form.time,
        instructor: this.form.instructorName,
        instructorEmail: this.form.instructorEmail
      }).then(this.sent = true)
    }
  }
}
</script>
